import React from "react";

import "./index.scss";

const ReportsIcon = props => (
  <svg id="Reports_SVG" data-name="Reports" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" className="reports-icon">
    <g id="Reports" data-name="Reports" transform="translate(16 16)">
      <g id="Group_8753" data-name="Group 8753" transform="translate(-16 -16)" className={`default ${props.active ? "active" : ""}`}>
        <path id="Path_8601" data-name="Path 8601" className="cls-1" d="M0,0H32V32H0Z" />
        <path
          id="Path_8602"
          data-name="Path 8602"
          className="cls-2"
          d="M8.206,28.274a1.937,1.937,0,0,1-1.929-1.941V5.63A1.943,1.943,0,0,1,8.218,3.69H18.3l7.384,7.384V26.333a1.943,1.943,0,0,1-1.941,1.941Z"
        />
        <path
          id="Path_8603"
          data-name="Path 8603"
          className="cls-3"
          d="M18.3,4.345V10.82a.271.271,0,0,0,.272.271l6.459-.015a.272.272,0,0,0,.191-.464L18.765,4.153A.271.271,0,0,0,18.3,4.345Z"
        />
        <g id="Group_8761" data-name="Group 8761">
          <rect id="Rectangle_276" data-name="Rectangle 276" className="cls-4" width="9.057" height="1.294" transform="translate(11.453 21.659)" />
          <rect id="Rectangle_277" data-name="Rectangle 277" className="cls-4" width="9.057" height="1.294" transform="translate(11.453 16.483)" />
        </g>
      </g>
    </g>
  </svg>
);

export default ReportsIcon;
